import { WCDocumentRequest } from "./document-request";

const WC_DOCUMENT_REQUEST_PATH = "/document-request";

export { WCDocumentRequest, WC_DOCUMENT_REQUEST_PATH };
